import React from 'react';
import ReactDOM from 'react-dom';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, SearchBox, connectStats } from 'react-instantsearch-dom';

import { GetAlgoliaIndex } from '3-components/Utils/AlgoliaUtils';
import Icon from '3-components/Icon/Icon';
import HeaderSearchHits from './widgets/HeaderSearchHits';
import { dataLayerSearch } from '../../js/utils/dataLayers';

const APP_CLASS = '.header-search';
const ALGOLIA_APP_ID = '1K2NLKV3ZJ';
const ALGOLIA_API_ID = '7a32b5b2e4b7dcec55dcb2efc053fedd';
const ALGOLIA_INDEX = 'ALL_PAGES';
const fedSearchResultPageURL = '/search-result.html';

const searchClient = algoliasearch(
    ALGOLIA_APP_ID,
    ALGOLIA_API_ID
);

interface HeaderSearchProps {
    searchResultPageUrl?: string;
}

const Stats = ({ nbHits }) => <div className="header-hits">{nbHits}</div>;
const HeaderStats = connectStats(Stats);

const HeaderSearchSearch = ({ searchResultPageUrl }: HeaderSearchProps) => {
    const indexToUse = GetAlgoliaIndex(ALGOLIA_INDEX);
    const searchURL = `${searchResultPageUrl ? searchResultPageUrl : fedSearchResultPageURL}?query=`;

    return (
        <InstantSearch
            indexName={indexToUse}
            searchClient={searchClient}
        >
            <div className="header-search-input">
                <>
                    <SearchBox
                        submit={<Icon icon="search" />}
                        reset={<Icon icon="remove" />}
                        translations={{ placeholder: 'Search' }}
                        onFocus={event => {
                            event.target.closest('.header-search').classList.add('active');
                        }}
                        onBlur={event => {
                            if (!event.target.value.length > 0) {
                                event.target.closest('.header-search').classList.remove('active');
                            }
                        }}
                        onSubmit={event => {
                            event.preventDefault();
                            const searchHits = document.getElementsByClassName('header-hits');
                            let numResult = '';
                            for (let i = 0; i < searchHits.length; i += 1) {
                                if (searchHits[i].textContent !== '') {
                                    numResult = searchHits[i].textContent;
                                    dataLayerSearch(event.target[0].value, parseInt(numResult, 10));
                                }
                            }
                            const encoded = encodeURIComponent(event.target[0].value);
                            window.location.href = `${searchURL}${encodeURIComponent(encoded)}`;
                        }}
                    />
                    <HeaderStats />
                </>
            </div>

            <HeaderSearchHits />
        </InstantSearch>
    );
};
const el = document.querySelectorAll(`${APP_CLASS}`);

if (el) {
    el.forEach(element => {
        const elProps = (element as HTMLElement).dataset.props || '{}';
        const propsObj = JSON.parse(elProps);

        ReactDOM.render(
            <HeaderSearchSearch {...propsObj} />,
            element
        );
    });
}
